"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.PFAHeroCarousel = void 0;
var _pfaHeroCarousel = _interopRequireDefault(require("./components/pfa-hero-carousel"));
exports.PFAHeroCarousel = _pfaHeroCarousel["default"];